<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import BaileysCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/BaileysCampaign/BaileysCampaignForm.vue';

const emit = defineEmits(['close']);
const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);
    useAlert(t('BAILEYS_CAMPAIGN.CREATE.FORM.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('BAILEYS_CAMPAIGN.CREATE.FORM.API.ERROR_MESSAGE'));
  }
};

const handleSubmit = campaignDetails => addCampaign(campaignDetails);
const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[28rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[85vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12 flex-shrink-0">
        {{ t('BAILEYS_CAMPAIGN.CREATE.TITLE') }}
      </h3>
      <BaileysCampaignForm @submit="handleSubmit" @cancel="handleClose" />
    </div>
  </div>
</template>
